
    import {Component, Prop, Vue} from 'vue-property-decorator'
    import {isOptionalGoods, ShopGoodsListDto} from "@/api/shoppingMall";
    import PackageSelector from "@/components/PackageSelector/index.vue";
    import {Getter} from "vuex-class";

    @Component({
        name: 'GoodsResultCard',
        components: {PackageSelector}
    })
    export default class GoodsResultCard extends Vue {
        @Getter companyId!: string
        @Getter providerId!: string

        @Prop({
            default: () => {
            }
        }) goods!: ShopGoodsListDto;

        toDetail(id: string, isValid: boolean) {
            if(isValid !== false) {
                const params = {
                    shopId: this.providerId,
                    goodsId: id,
                    customerId: this.companyId,
                }
                isOptionalGoods(params).then((res) => {
                    if (res.data.isOptional) {
                        this.$router.push({
                            path: '/goodsDetail',
                            query: {
                                goodsId: id
                            }
                        })
                    } else {
                        this.$dialog.alert({
                            message: '商品过期不存在'
                        }).then(() => {
                            this.$emit('reloadList')
                        })
                    }
                }).catch(() => {
                })
            }
        }

        joinBuyCar(id: string) {
            const params = {
                shopId: this.providerId,
                goodsId: id,
                customerId: this.companyId,
            }
            isOptionalGoods(params).then((res) => {
                if (res.data.isOptional) {
                    (this.$refs.packageSelector as any).show({
                        ruleType: '1',
                        detailInfo: this.goods,
                        defaultInfo: this.goods
                    })
                } else {
                    this.$dialog.alert({
                        message: '商品过期不存在'
                    }).then(() => {
                        this.$emit('reloadList')
                    })
                }
            }).catch(() => {
            })
        }
    }
